/**
 * Display-name helpers for the payouts surface (AUT-128). Mirrors the
 * inspectors / orders / reports versions — kept page-local so the payouts
 * page never imports across sibling vertical boundaries.
 *
 * The server sends `inspectorName` already redacted-or-full per
 * `piiRevealed`. These helpers only derive avatar initials + a short id
 * from values the SPA already holds — they never reconstruct PII.
 * Cyrillic-aware so the initials of "Мария Ковалёва" render as "МК".
 */

/** Two-letter avatar initials from a display name; '—' fallback. */
export const initials = (name: string | null): string => {
  if (!name) return '—';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0];
  if (!first) return '—';
  const second = parts[1];
  if (!second) return first.slice(0, 2).toLocaleUpperCase();
  return ((first[0] ?? '') + (second[0] ?? '')).toLocaleUpperCase();
};

/** Truncate a payout id to the mockup's `pay_a91f…3c0` shape. */
export const shortId = (id: string): string => {
  if (id.length <= 11) return id;
  return `${id.slice(0, 8)}…${id.slice(-3)}`;
};
